import { ReadonlyField } from '@shared/components';

import { ReviewResultLabel } from '../../components';
import { useQuestionReviewTaskQuestionDetailsFormContext } from '../../providers';

export default function QuestionReviewResultView() {
  const { getValues } = useQuestionReviewTaskQuestionDetailsFormContext();

  const result = getValues('result');

  return <ReadonlyField label='ผลการทบทวน' content={<ReviewResultLabel verdict={result} />} />;
}
